// @ts-strict-ignore
import { NavButton } from './NavButton'
import { useProductSlider } from './hooks/use-product-slider'
import { Image } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC, useRef } from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from '@components/old-rolex-ui'

interface Props {
  activeIndex?: number
  onChange: (index: number) => void
  title: string
  sources: string[]
  onSet360View?: () => void
}

export const productSliderContainerClassName = cn(
  'scrollbar-hidden relative flex w-full snap-x snap-mandatory overflow-x-scroll',
  'lg:overflow-hidden',
  'before:block before:pt-[90%]',
)

export const productSliderItemClassName =
  'relative flex aspect-square min-w-full snap-start items-center justify-center'

const ProductSlider: FC<Props> = ({ activeIndex, onChange, title, sources, onSet360View }) => {
  const ref = useRef<HTMLDivElement>(null)
  const { handlePrev, handleNext } = useProductSlider(ref, activeIndex, sources.length, onChange)
  const { t } = useTranslation('rolex')

  return (
    <>
      <div className="relative w-full">
        <NavButton direction="left" onClick={handlePrev} />
        <div className={productSliderContainerClassName} ref={ref}>
          {sources.map((src, index) => (
            <div className={productSliderItemClassName} key={src}>
              <Image
                alt={`${title} - ${index + 1}/${sources.length}`}
                sources={[src]}
                placeholderSrc="https://placehold.it/20x20"
                loading={index === 0 ? 'eager' : 'delayed'}
                className="absolute h-full w-full"
              />
            </div>
          ))}
        </div>
        <NavButton direction="right" onClick={handleNext} />
        {onSet360View && (
          <div className="absolute bottom-8 right-8 z-[2]">
            <Button variant="secondary" onClick={onSet360View}>
              {t('detail.360View')}
            </Button>
          </div>
        )}
      </div>
    </>
  )
}

export default ProductSlider
